import * as Actions from 'store/actions/app/treasury.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_treasuries_by_year: false,
  treasuries_by_year: [],

  loading_treasury_openings: false,
  treasury_openings: [],

  saving_treasury_opening: false,
  saved_treasury_opening: false,

  saving_treasury_closing: false,
  saved_treasury_closing: false,

  undoing_treasury_closing_ids: [],
  undone_treasury_closing_ids: [],

  voiding_treasury_ids: [],
  voided_treasury_ids: [],

  loading_cash_registers_by_treasury: false,
  cash_registers_by_treasury: [],

  loading_movements_by_treasury: false,
  movements_by_treasury: [],

  loading_detailed_amounts_by_treasury: false,
  detailed_amounts_by_treasury: null
}

export default function treasuryReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.GET_TREASURIES_BY_YEAR: {
      return {
        ...state,
        loading_treasuries_by_year: action.payload.loading ?? state.loading_treasuries_by_year,
        treasuries_by_year: action.payload.data ?? state.treasuries_by_year
      }
    }
    case Actions.GET_TREASURY_OPENINGS: {
      return {
        ...state,
        loading_treasury_openings: action.payload.loading ?? state.loading_treasury_openings,
        treasury_openings: action.payload.data ?? state.treasury_openings,
      }
    }
    case Actions.SAVE_TREASURY_OPENING: {
      return {
        ...state,
        saving_treasury_opening: action.payload.saving ?? state.saving_treasury_opening,
        saved_treasury_opening: action.payload.saved ?? false,
        treasuries_by_year: action.payload.data
          ? addOrUpdateObjectInArray(state.treasuries_by_year, action.payload.data, 'tesoreria_id', true)
          : state.treasuries_by_year,
      }
    }
    case Actions.SAVE_TREASURY_CLOSING: {
      return {
        ...state,
        saving_treasury_closing: action.payload.saving ?? state.saving_treasury_closing,
        saved_treasury_closing: action.payload.saved ?? false,
        treasuries_by_year: action.payload.data
          ? addOrUpdateObjectInArray(state.treasuries_by_year, action.payload.data, 'tesoreria_id')
          : state.treasuries_by_year,
      }
    }
    case Actions.UNDO_TREASURY_CLOSING: {
      return {
        ...state,
        undoing_treasury_closing_ids: toggleIdInArray(state.undoing_treasury_closing_ids, action.payload.undoing_id),
        undone_treasury_closing_ids: toggleIdInArray(state.undone_treasury_closing_ids, action.payload.undone_id),
        treasuries_by_year: action.payload.data
          ? addOrUpdateObjectInArray(state.treasuries_by_year, action.payload.data, 'tesoreria_id')
          : state.treasuries_by_year,
      }
    }
    case Actions.VOID_TREASURY: {
      return {
        ...state,
        voiding_treasury_ids: toggleIdInArray(state.voiding_treasury_ids, action.payload.voiding_id),
        voided_treasury_ids: toggleIdInArray(state.voided_treasury_ids, action.payload.voided_id),
        treasuries_by_year: state.treasuries_by_year.filter(item => item.tesoreria_id !== action.payload.voided_id)
      }
    }
    case Actions.GET_CASH_REGISTERS_BY_TREASURY: {
      return {
        ...state,
        loading_cash_registers_by_treasury: action.payload.loading ?? state.loading_cash_registers_by_treasury,
        cash_registers_by_treasury: action.payload.data ?? state.cash_registers_by_treasury,
      }
    }
    case Actions.GET_MOVEMENTS_BY_TREASURY: {
      return {
        ...state,
        loading_movements_by_treasury: action.payload.loading ?? state.loading_movements_by_treasury,
        movements_by_treasury: action.payload.data ?? state.movements_by_treasury,
      }
    }
    case Actions.GET_DETAILED_AMOUNTS_BY_TREASURY: {
      return {
        ...state,
        loading_detailed_amounts_by_treasury: action.payload.loading ?? state.loading_detailed_amounts_by_treasury,
        detailed_amounts_by_treasury: action.payload.data ?? state.detailed_amounts_by_treasury,
      }
    }
    default: {
      return state
    }
  }
}
